




























import { Component, Vue,Inject,Prop,Emit } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
@Component
export default class extends AbpBase {
    name:string='sidebarMenuShrink';
    @Prop({type:Array}) menuList:Array<any>;
    @Prop({default:'white'}) iconColor:string;
    @Prop({default:'light'}) menuTheme:string;
    @Emit('on-change') changeMenu(active:string){

    }
    get menuListFilter() {
        let menuList = JSON.parse(JSON.stringify(this.menuList))
        let list = menuList.filter(item => {
            if(item.children && item.children.length > 0) {
              let child = item.children.filter(child => {
                if(!child.hidden) {
                  return child
                }
              })
              item.children = child
            }
            if(!item.hidden) {
               return item
            }
        })
        return list
    }
    itemTitle(item:any){
        return this.L(item.meta.title);
    }
}
